import axios from "./utils/axios_fetch";
import { IS_DEV } from "base/constants";


const dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}

gtag('js', new Date());

function track_event(event, data){
    if (!IS_DEV) {
        gtag('event', event, data);
    } else {
        console.log('event', event, data);
    }
}

axios.interceptors.response.use(undefined, function (error) {
    const statusCode = error.response ? error.response.status : null;
    track_event("error", {"status_code": statusCode});
    return Promise.reject(error);
});

function log_error(data) {
    if (!IS_DEV) {
      axios.post('/jserror', {stacktrace_string: JSON.stringify(data)}).catch((err) => {
        console.error('Failed to log error to server:', err);
      });
    } else {
        console.log('js-error', data);
    }
}


window.onunhandledrejection = function (event) {
  const reason = event.reason;
  if (reason instanceof Error) {
    log_error({"description": reason.stack, "error_details": reason.message});
  } else {
    log_error({"error_details": reason.toString()});
  }
};
window.onerror = function(message, source, lineno, colno, error) {
    var error_details = 'Script: '+ source + ':'+ lineno + ':'+ colno ; 
    log_error({
      "description": error ? error.stack : error_details,
      'error_details': error_details
    });
}

function sendWebVitalsToAnalytics(data) {
  const {name, value, attribution, rating} = data;
  const eventParams = {
    duration: value,
    id: name,
    status_code: rating
  }

  switch (name) {
    case 'CLS':
      eventParams.debug_string = attribution.largestShiftTarget;
      break;
    case 'LCP':
      eventParams.debug_string = attribution.element;
      break;
    case 'FID':
      eventParams.debug_string = attribution.eventTarget;
      break;
  }

  track_event('web_vitals', eventParams);
}

const reportWebVitals = (onPerfEntry) => {
  import('web-vitals/attribution').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
    onCLS(onPerfEntry);
    onINP(onPerfEntry); // ✅ replaces onFID https://web.dev/articles/fid
    onFCP(onPerfEntry);
    onLCP(onPerfEntry);
    onTTFB(onPerfEntry);
  });
};


export {gtag, track_event, reportWebVitals, sendWebVitalsToAnalytics};
